// extracted by mini-css-extract-plugin
export default {"default":"LayoutAppLight__default___Pc88k"};